class RoleUtil {

    static CALL_CENTER_AGENT = 'CALL_CENTER_AGENT';
    static DUI_ADMIN = 'DUI_ADMIN';
    static DUI_SERVICE_ADVISOR = 'DUI_SERVICE_ADVISOR';
    static NSC_ADMIN = 'NSC_ADMIN';
}

export default RoleUtil;
